export const environment = {
  env: 'prod',
  production: true,
  maintenance: false,
  url_site: 'https://apps.calia.ai/',
  url_api: 'https://api.calia.ai/api/',
  title: 'Prod Environment',
  i18nFolder: 'assets/i18n/',
  s3BucketUrl: 'https://app-calia-assets.s3.amazonaws.com/',
  superAdmins: ['admin@calia.com.co'],
  openpay: {
    merchantId: 'm42by0bxsbs8zsm8zuhp',
    publicKey: 'pk_467fa5bb8b7d4ce8a764f6a7afd13bac',
    sandboxMode: false,
    sdkUrl: 'https://resources.openpay.co/openpay.v1.min.js',
    sdkDataUrl: 'https://resources.openpay.co/openpay-data.v1.min.js',
    apiHostname: 'https://api.openpay.co/v1/',
    sandboxApiHostname: 'https://sandbox-api.openpay.co/v1/',
  },
  featureFlags: {
    formEntriesUserIds: [
      '6388e4fd70ecce183783b13c',
      '628e39a3ef88905953b1b8b7',
      '65fc452983ac5d063aa52b0f',
      '65d79e5783ac5d063aa50585',
    ],
  },
};
